import { FormTextInputPrintEditor } from '../text-input/FormTextInputPrintEditor'

export const FormNumericInputPrintEditor = (props) => {
  return <FormTextInputPrintEditor {...props} />
}
